import React, { Component } from "react";
import { withRouter, Route } from "react-router-dom";
import { connect } from "react-redux";
import styled from "styled-components";
import { withTranslation, withNamespaces } from "react-i18next";

// component
import Scratch from "../../Components/Scratch";
import Roulette from "../../Components/Roulette";
import Logo from "../../Components/Logo";
import Footer from "../../Components/Footer/footer";
import LoginComponent from "../../Containers/Authentication";
import Spinner from "../../Components/Spinner";
import ModalSmallComponent from "../../Components/modal/ModalSmall";

// styles
import eventStyle from "../../Styles/Containers/Event.module.css";

// Utils
import { parseUrlParameter } from "../../Lib/Utils";

// Const
import {
  getSession,
  MESSAGE_TABLE,
  LOGIN_WARNING_MESSAGE
} from "../../Data/const";
import { action } from "../../Data";
import * as Const from "../../Data/const";

class EventContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDetail: false, // 인증이 아닌 단순히 상세 페이지를 볼때 true

      eventKind: "scratch",
      isEventVisible: true,
      isLoading: false,
      code: null,

      locale: "en",

      event: {},
      company: {},
      logEvent: {},

      prizeResult: {},

      isTriggered: false,

      showIsPrized: false,
      showIsExpired: false,
      showResult: false,

      isPrizeLoading: false,

      loginData: {},
      isLoginVisible: false
    };

    this.init = this.init.bind(this);
    this.getEventInfo = this.getEventInfo.bind(this);
    this.checkIsLogin = this.checkIsLogin.bind(this);
    this.handleLoginSuccess = this.handleLoginSuccess.bind(this);
    this.handleEventJoin = this.handleEventJoin.bind(this); // 이벤트 작동 시작, 당첨될 상품 미리 불러옴
    this.handleEventSubmit = this.handleEventSubmit.bind(this); // 이벤트 작동 끝, 당첨될 상품을 당첨시킨다
    this.handleResultModal = this.handleResultModal.bind(this); // 이벤트 작동 끝, 당첨될 상품을 당첨시킨다
    this.handleCloseModal = this.handleCloseModal.bind(this); // 이벤트 작동 끝, 당첨될 상품을 당첨시킨다
    this.handleQnAUrl = this.handleQnAUrl.bind(this);
  }

  componentDidMount() {
    // 토큰 지우기용
    //localStorage.setItem(Const.TOKEN['user'], '')
    this.init();
  }

  init() {
    this.getEventInfo((err, event) => {
      if (err) {
        console.log(err);
        if (err.code === "WRONG_ACCESS") {
          Const.showAlert("", err.message);
          Const.userAppCloseActivity();
          return;
        } else if (err.code === "MSG_EVENT_EXPIRED") {
          this.setState({ showIsExpired: true }, () => {
            return;
          });
        } else if (err.code === "MSG_EVENT_NOT_EXISTS") {
          Const.showAlert(
            "",
            Const.MESSAGE_TABLE[this.state.locale].EVENT_NOT_EXISTS
          );
          this.setState({ isEventVisible: false });
          Const.userAppCloseActivity();
        } else {
          alert("Network Error ::: ", err);
          Const.userAppCloseActivity();
        }
      } else {
        this.handleEventJoin();
      }
    });
  }

  getEventInfo(CB) {
    let query = parseUrlParameter.parse(this.props.location.search);

    if (!query.event_id)
      return CB({
        message: MESSAGE_TABLE[this.state.locale].EVENT_WRONG_ACCESS_MESSAGE,
        code: "WRONG_ACCESS"
      });
    let locale = query.locale;
    this.setState(
      {
        code: query.id || null,
        isDetail: query.id ? false : true,
        locale:
          Const.COUNTRY_CODES.indexOf(locale) > -1
            ? locale
            : this.props.COUNTRY_CODE
      },
      () => {
        this.props
          .dispatch(
            action.eUSER.getUserEventGet({
              event_id: query.event_id
            })
          )
          .then(res => {
            if (
              !res.event ||
              !res.event._id ||
              !res.event[this.state.locale + "Event"]
            ) {
              return CB({ message: "No Event", code: "MSG_EVENT_NOT_EXISTS" });
            }
            this.setState(
              {
                event: res.event || {},
                company: res.company || {}
              },
              () => {
                return CB(null, null);
              }
            );
          })
          .catch(err => {
            let errData = Const.getError(err.response.data);

            return CB({ message: errData.errMessage, code: errData.code });
          });
      }
    );
  }

  checkIsLogin() {
    let loginData = this.props.eSESSION.user || null;

    if (!loginData) {
      this.setState({ isLoginVisible: true }, () => {
        return false;
      });
    } else {
      return true;
    }
  }

  handleQnAUrl(link) {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.iosHandler
    ) {
      Const.goLinkInIOS(link);
    } else {
      window.open(link);
    }
  }

  get isPrizedModal() {
    return (
      <ModalSmallComponent
        visible={this.state.showIsPrized}
        topContent={
          <img
            src={
              "https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-alert.svg"
            }
          ></img>
        }
        middleContent={this.props.t("sorry")}
        bottomContent={
          <React.Fragment>
            <span>{this.props.t("once_per_id")}</span>
          </React.Fragment>
        }
        confirmFont={this.props.t("ok")} //기본값 "확인" 값을 넘기면 해당 글자가 버튼에 표시
        onConfirm={() => {
          this.handleCloseModal();
        }}
      />
    );
  }

  get isExpiredModal() {
    return (
      <ModalSmallComponent
        visible={this.state.showIsExpired}
        topContent={
          <img
            src={
              "https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-closed.png"
            }
          ></img>
        }
        middleContent={this.props.t("closed_event")}
        bottomContent={
          <React.Fragment>
            <span>{this.props.t("wait_for_next_event")}</span>
          </React.Fragment>
        }
        confirmFont={this.props.t("ok")} //기본값 "확인" 값을 넘기면 해당 글자가 버튼에 표시
        onConfirm={() => {
          this.handleCloseModal();
        }}
      />
    );
  }

  get resultModal() {
    return (
      <ModalSmallComponent
        visible={this.state.showResult}
        topContent={this.state.prizeResult.topContent}
        middleContent={this.state.prizeResult.middleContent}
        bottomContent={this.state.prizeResult.bottomContent}
        confirmFont={this.props.t("ok")} //기본값 "확인" 값을 넘기면 해당 글자가 버튼에 표시
        onConfirm={() => {
          this.handleCloseModal();
        }}
      />
    );
  }

  handleLoginSuccess() {
    // 로그인 response 필요
    this.init();
  }

  // 이벤트 작동 시작, 당첨될 상품 미리 불러옴
  handleEventJoin() {
    if (!this.props.eSESSION.user) {
      this.setState({ isPrizeLoading: true });
      return;
    }
    if (this.state.isDetail) {
      return;
    }
    const loginData = this.props.eSESSION.user || null;
    const { event } = this.state;
    let query = Const.parseUrlParameter(this.props.location.search);

    if (event.EEventType == "QnA" || !loginData) {
      this.setState({ isPrizeLoading: true }, () => {
        return;
      });
    } else {
      const requiredUserVals = ["email", "name", "year", "ESex"];

      for (let required of requiredUserVals) {
        if (!loginData[required]) {
          this.props.history.push(
            "/user/event/input?event_id=" + query.event_id + "&id=" + query.id
          );
          return;
        }
      }

      if (!this.state.event._id) {
        Const.showAlert("", MESSAGE_TABLE[this.state.locale].EVENT_NOT_EXISTS);
      }

      if (this.state.event.EEventType == "QnA") return;

      let q = {
        event_id: this.state.event._id,
        ELocale: this.state.locale
      };

      this.props
        .dispatch(action.eEVENT.userEventJoin(q))
        .then(res => {
          let logEvent = res.logEvent || {};

          this.setState(
            {
              logEvent: logEvent
            },
            () => {
              this.setState({
                isPrizeLoading: this.state.logEvent.eventPrize != null
              });
            }
          );
        })
        .catch(err => {
          let errData = Const.getError(err.response.data);

          if (errData.code == "MSG_USER_IS_ALREADY_JOIN_EVENT") {
            this.setState({ showIsPrized: true });
          } else if (errData.code == "MSG_EVENT_EXPIRED") {
            this.setState({ showIsExpired: true });
          } else {
            Const.showAlert("", errData.errorMessage);
          }
        });
    }
  }

  // 이벤트 작동 끝, 당첨될 상품을 당첨시킨다
  handleEventSubmit() {
    if (!this.props.eSESSION.user) return;
    if (this.state.isTriggered) return;
    let q = {
      event_id: this.state.event._id,
      uid: this.props.eSESSION.user.uid,
      logEvent_id: this.state.logEvent._id
    };
    this.props
      .dispatch(action.eEVENT.userEventSubmit(q))
      .then(res => {
        this.setState({ isTriggered: true });
      })
      .catch(err => {
        let errData = Const.getError(err.response.data);
        Const.showAlert("", errData.errorMessage);
      });
  }

  handleResultModal() {
    const eventPrize = this.state.logEvent.eventPrize;
    let prizeResult = {};

    if (eventPrize.EPrizeType == "void") {
      prizeResult.topContent = (
        <img
          src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-cry.png"}
        ></img>
      );
      prizeResult.middleContent = eventPrize.name;
      prizeResult.bottomContent = (
        <EventResultDetail>
          {this.props.t("wait_for_next_event")}
        </EventResultDetail>
      );
    } else {
      prizeResult.topContent = (
        <EventResultHeader>
          <img
            src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-win.png"}
          />
          {this.props.t("event_result")}
        </EventResultHeader>
      );
      prizeResult.middleContent = (
        <EventResultPrize>
          {eventPrize.EPrizeType === "image" ? (
            <>
              <div
                className={"prizeImage"}
                style={{ backgroundImage: "url('" + eventPrize.image + "')" }}
              />
              <div className={"prizeName"}>{eventPrize.detail}</div>
            </>
          ) : (
            <>
              <div className={"prizeText"}>{eventPrize.name}</div>
              <div className={"prizeDetail"}>{eventPrize.detail}</div>
            </>
          )}
        </EventResultPrize>
      );
      prizeResult.bottomContent = (
        <EventResultDetail>
          {this.props.t("find_in_authentication_detail")}
        </EventResultDetail>
      );
    }

    this.setState({
      showResult: true,
      prizeResult: prizeResult
    });
  }

  handleCloseModal() {
    if (!this.state.code) {
      this.setState({
        showIsPrized: false,
        showIsExpired: false,
        showResult: false,
        isLoginVisible: false
      });
      return;
    }
    this.props.history.push(
      "/user/product?id=" + this.state.code + "&eventJoin=true"
    );
  }

  render() {
    const event = this.state.event || {};
    const company = this.state.company || {};
    const localEvent = event[this.state.locale + "Event"] || {};

    let renderEventPage = () => {
      const event = this.state.event;

      let qnaPage = event => {
        return (
          <>
            <div className={eventStyle.surveyWrapper}>
              <div onClick={() => this.handleQnAUrl(localEvent.url)}>
                <img src={localEvent.image} alt={"event_image"} />
              </div>
            </div>
          </>
        );
      };

      let roulettePage = event => {
        return (
          <>
            <div className={eventStyle.title}>
              <span className={eventStyle.title_font}>{localEvent.name}</span>
            </div>
            <span className={eventStyle.title_small}>{localEvent.detail}</span>
            <div>
              <Roulette
                localEvent={localEvent}
                eventPrize={this.state.logEvent.eventPrize}
                eventSubmit={() => this.handleEventSubmit()}
                checkIsLogin={() => this.checkIsLogin()}
                handleResultModal={() => this.handleResultModal()}
              />
            </div>
          </>
        );
      };

      let lottoPage = event => {
        return (
          <>
            <div className={eventStyle.title}>
              <span className={eventStyle.title_font}>{localEvent.name}</span>
            </div>
            <span className={eventStyle.title_small}>{localEvent.detail}</span>
            <div style={{ marginTop: "30px" }}>
              <Scratch
                localEvent={localEvent}
                eventPrize={this.state.logEvent.eventPrize}
                eventSubmit={() => this.handleEventSubmit()}
                checkIsLogin={() => this.checkIsLogin()}
                handleResultModal={() => this.handleResultModal()}
              />
            </div>
          </>
        );
      };
      let renderPage = (
        <div className={eventStyle.spinnerWrapper}>
          <Spinner />
        </div>
      );
      if (event.EEventType === "QnA") {
        renderPage = qnaPage(event);
      } else if (event.EEventType === "roulette") {
        renderPage = roulettePage(event);
      } else if (event.EEventType === "lotto") {
        renderPage = lottoPage(event);
      }
      return renderPage;
    };

    let renderEventBg = () => {
      let eventBg = null;

      if (event.EEventType === "roulette") {
        eventBg = (
          <img
            className={eventStyle.background}
            src={
              "https://d15eixcc3515pq.cloudfront.net/Assets/img/bg-roulette.svg"
            }
          />
        );
      } else if (event.EEventType === "lotto") {
        eventBg = (
          <img
            className={eventStyle.background}
            src={
              "https://d15eixcc3515pq.cloudfront.net/Assets/img/bg-lottery.svg"
            }
          />
        );
      }
      return eventBg;
    };

    return (
      <div className={eventStyle.container}>
        {this.state.showIsPrized ? this.isPrizedModal : null}
        {this.state.showIsExpired ? this.isExpiredModal : null}
        {this.state.showResult ? this.resultModal : null}

        {this.state.isLoginVisible ? (
          <LoginComponent
            onRef={ref => {
              this.loginRef = ref;
            }}
            loginSuccess={this.handleLoginSuccess}
            handleClose={this.handleCloseModal}
            modalContents={{
              title: this.props.t("sns_login"),
              info: this.props.t("login_required_for_event")
            }}
          />
        ) : null}
        {this.state.isPrizeLoading && this.state.isEventVisible ? (
          <div style={{ minHeight: window.innerHeight }}>
            {renderEventBg()}
            {event.EEventType == "QnA" ? (
              <Logo
                imgSrc={company.logoUrl}
                customStyle={{ marginBottom: "24px" }}
              /> // 기존 nulll 이었음
            ) : (
              <Logo
                imgSrc={company.logoUrl}
                customStyle={{ marginBottom: "24px" }}
              />
            )}
            <div className={eventStyle.title_area}>{renderEventPage()}</div>
            <Footer
              content={this.props.t("close")}
              onClick={() =>
                this.state.code
                  ? this.props.history.push(
                      "/user/product?id=" + this.state.code + "&eventJoin=true"
                    )
                  : null
              }
            />
          </div>
        ) : (
          <div className={eventStyle.spinnerWrapper}>
            <Spinner />
          </div>
        )}
      </div>
    );
  }
}

const EventResultHeader = styled.div`
  text-align: center;
  color: #ff7d40;
  font-size: 24px;
  font-weight: bold;
  line-height: 29px;

  img {
    width: 64px;
    height: 64px;

    margin: 0 auto 16px;
    display: block;
  }
`;

const EventResultPrize = styled.div`
  .prizeImage {
    width: 106px;
    height: 106px;
    margin: 0 auto;

    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .prizeName {
    margin-top: 8px;
    margin-bottom: 31px;
    width: 100%;
    max-width: 233px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    color: #333;
    font-size: 18px;
    font-weight: bold;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .prizeText {
    margin-top: 40px;
    text-align: center;
    color: #333;
    font-size: 26px;
    font-weight: bold;
    width: 100%;
    max-width: 233px;
    line-height: 30px;
    height: auto;
  }

  .prizeDetail {
    margin-top: 16px;
    margin-bottom: 70px;
    width: 100%;
    max-width: 233px;
    color: #555;
    font-size: 16px;
  }
`;

const EventResultDetail = styled.div`
  width: 100%;
  max-width: 233px;
`;

export default connect(state => {
  return {
    eSESSION: state.data.eSESSION.eSESSION,
    COUNTRY_CODE: state.data.eSESSION.COUNTRY_CODE
  };
})(withRouter(withTranslation()(EventContainer)));
